<input
  id="range-control"
  #rangeControl
  type="range"
  min="0"
  [max]="rpoOptions.length - 1"
  [value]="currentOptionIndex"
  (input)="sliderChange()"
/>
